import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { IEnvioVehiculo, IFilter, IPopulate, IQueryParam } from 'modelos/src';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { ConfigEventoUsuarioService } from '../../../../../auxiliares/servicios/http/config-evento-usuario.service';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { IColumnas } from '../../../../../auxiliares/tabla/tabla.component';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';

@Component({
  selector: 'app-listado-envios-vehiculos',
  templateUrl: './listado.component.html',
  standalone: false,
})
export class ListadoEnviosVehiculosComponent implements OnInit, OnDestroy {
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(ConfigEventoUsuarioService);
  dialog = inject(MatDialog);

  //// Tabla nueva
  public name = 'ListadoEnviosVehiculosComponent';
  public EnviosVehiculos: IEnvioVehiculo[];
  public enviosVehiculos$?: Subscription;
  public totalCount = 0;
  public columnas?: IColumnas<IEnvioVehiculo>[];
  public search: IRegExpSearch = {
    fields: [],
  };
  // FILTROS
  public vehiculosFilter: IFiltroTabla = {
    filter: {
      field: 'idActivo',
    },
    label: 'Vehículo',
    tipo: 'activo-selector',
    categoriaActivo: 'Vehículo',
  };
  public conductor: IFiltroTabla = {
    filter: {
      field: 'idConductor',
    },
    label: 'Conductor',
    tipo: 'usuario-selector',
    funciones: ['Conductor'],
  };

  public filtros: IFiltroTabla[] = [this.vehiculosFilter, this.conductor];

  public filter: IFilter<IEnvioVehiculo> = {};
  public populate: IPopulate[] = [
    {
      path: 'cliente',
      select: 'nombre',
    },
    {
      path: 'usuario',
      select: 'usuario datosPersonales.nombre',
    },
    {
      path: 'conductor',
      select: 'usuario datosPersonales.nombre',
    },
    {
      path: 'activo',
      select: 'identificacion',
    },
  ];
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
    sort: '-fechaCreacion',
  };

  public async listar(): Promise<void> {
    let filter: IFilter<IEnvioVehiculo> = {};
    if (this.query.filter) {
      filter = JSON.parse(this.query.filter);
    }
    this.query.filter = JSON.stringify(filter);
    //
    this.enviosVehiculos$?.unsubscribe();
    this.enviosVehiculos$ = this.lista2
      .envioVehiculos(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.EnviosVehiculos = data.datos;
      });
  }

  public async eliminar(estado: IEnvioVehiculo) {
    const res = await this.dialogService.confirm(
      'Confirmá la acción',
      `¿Querés eliminar el estado?`,
    );
    if (!res) return;
    try {
      await this.service.delete(estado._id!);
      this.helper.notifSuccess('Estado eliminado');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  private setColumnas() {
    const cols: IColumnas<IEnvioVehiculo>[] = [
      {
        header: {
          label: 'Fecha de creación',
          sortable: true,
          sort: 'fechaCreacion',
        },
        row: {
          fecha: (dato) => dato.fechaCreacion,
          hace: true,
          noData: 'Sin fecha de creación',
        },
      },
      {
        header: {
          label: 'Fecha de finalización',
          sortable: true,
          sort: 'fechaFinalizacion',
        },
        row: {
          fecha: (dato) => dato.fechaFinalizacion,
          noData: 'Sin fecha de finalización',
        },
      },
      {
        header: {
          label: 'Asignado por',
        },
        row: {
          parse(dato) {
            return (
              dato?.usuario?.datosPersonales?.nombre || dato?.usuario?.usuario
            );
          },
          noData: 'Sin asignador',
        },
      },
      {
        header: {
          label: 'Conductor asignado',
        },
        row: {
          parse(dato) {
            return (
              dato?.conductor?.datosPersonales?.nombre ||
              dato.conductor?.usuario
            );
          },
          noData: 'Sin conductor',
        },
      },
      {
        header: {
          label: 'Vehículo',
        },
        row: {
          parse(dato) {
            return dato?.activo?.identificacion;
          },
          noData: 'Sin vehículo',
        },
      },
    ];

    this.columnas = cols;
  }

  // Hooks

  async ngOnInit() {
    this.setColumnas();
    await this.listar();
  }

  async ngOnDestroy() {
    this.enviosVehiculos$?.unsubscribe();
  }
}
